import UnProtectedRoute from "../../routes/UnProtectedRoute";

const LoginPage = () => {


  return (
    <UnProtectedRoute>

    </UnProtectedRoute>
  );
};

export default LoginPage;